<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>

      <v-dialog v-model="dialog" persistent max-width="450px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>

            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout wrap>
                      <div class="flex md12">

                        <div v-show="codegorunum === true ">



                          <v-text-field :color="color" hide-details :label="$t('Credit-Card-No')" v-model="Firma.KrediKartNo"
                            :error-messages="errors.collect('kartno')" v-validate="'required|min:16'"
                            data-vv-name="kartno" required>
                          </v-text-field>
                        </div>

                        <v-select :items="karttipi" hide-details :color="color" clearable v-model="Firma.KrediKartTip"
                          :error-messages="errors.collect('selectkarttipi')" v-validate="'required'"
                          data-vv-name="selectkarttipi" :label="$t('Credit-Card-Type-v2')" item-text="text" item-value="id">
                        </v-select>

                        <v-select :items="sonkullanimAy" hide-details :color="color" clearable v-model="Firma.Ay"
                          :error-messages="errors.collect('selectsonkullanim')" v-validate="'required'"
                          data-vv-name="selectsonkullanim" :label="$t('Credit-Card-Expiry-Month')" item-text="text"
                          item-value="id"></v-select>

                        <v-select :items="sonkullanimYil" hide-details :color="color" clearable v-model="Firma.Yil"
                          :error-messages="errors.collect('selectsonkullanimyil')" v-validate="'required'"
                          data-vv-name="selectsonkullanimyil" :label="$t('Credit-Card-Expiry-Year')" item-text="text"
                          item-value="id"></v-select>




                        <muhasebekoducomp v-model="Firma.MuhasebeKodu" :etiket="$t('Accounting-Code')"></muhasebekoducomp>

                        
                        <cariaracomp tabindex="1" v-bind:etiket="$t('Select-Current-Account')" v-bind:value="Firma.CariKod" v-bind:renk="color" :loading="loading" 
                                  v-model="Firma.CariKod"></cariaracomp>

                        <v-text-field hide-details :label="$t('Bank-Code')" :color="color" v-model="Firma.BankaKod">
                        </v-text-field>
                        <v-checkbox hide-details small :label="$t('Passify-this-card')" v-model="Firma.PasifAktif"  color="green">
                        </v-checkbox>
                      </div>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
            <div v-show="m === true">


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletefirma()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>
            </div>
            <div v-show="k === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>

            </div>


          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="baslikfont">{{$t('Company-Card')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>


        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="kartekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Company-Card')}) }}  </span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Company-Card')}) }}</span>
        </v-tooltip>

      </v-toolbar>
    </v-layout>



    <v-card>
      <v-flex xs12 sm12 pa-2 md12>
      <v-checkbox small :label="$t('Show-passive-cards')" v-model="pasifKayitlar" hide-details color="green"></v-checkbox>
      </v-flex>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :items="items" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.KrediKartNo)" item>
            <td class="text-xs-left">{{ props.item.KrediKartNo }}</td>
            <td class="text-xs-left">{{ props.item.Ay }}</td>
            <td class="text-xs-left">{{ props.item.Yil }}</td>
            <td class="text-xs-left">{{ props.item.KrediKartTip }}</td>
            <td class="text-xs-left">{{ props.item.CariKod }}</td>
            <td class="text-xs-left">{{ props.item.PasifAktif | aktifpasifgoruntu }}</td>

          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
  import cariaracomp from '@/components/app/customcomp/cariaracomp'

  export default {
    data() {
      return {
        pasifKayitlar:false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: this.$t('Card-Number'),
            value: 'KrediKartNo'
          },
          {
            text: this.$t('Month'),
            value: 'Ay'
          },
          {
            text: this.$t('YEAR'),
            value: 'Yil'
          },
          {
            text: this.$t('Card-Type'),
            value: 'KrediKartTip'
          },
          {
            text: this.$t('Currentcode_label'),
            value: 'CariKod'
          }, {
            text: this.$t('Active') + '/' + this.$t('Passive'),
            value: 'PasifAktif'
          },

        ],
        loading: false,
        items: [],
        search: null,
        select: [],
        karttipi: [{
            id: 'M',
            text: 'Master Card'
          },
          {
            id: 'VI',
            text: 'VISA'
          },
          {
            id: 'A',
            text: 'American Express'
          },
        ],
        sonkullanimAy: [{
            id: '01',
            text: '1'
          },
          {
            id: '02',
            text: '2'
          },
          {
            id: '03',
            text: '3'
          },
          {
            id: '04',
            text: '4'
          },
          {
            id: '05',
            text: '5'
          },
          {
            id: '06',
            text: '6'
          },
          {
            id: '07',
            text: '7'
          },
          {
            id: '08',
            text: '8'
          },
          {
            id: '09',
            text: '9'
          },
          {
            id: '10',
            text: '10'
          },
          {
            id: '11',
            text: '11'
          },
          {
            id: '12',
            text: '12'
          }
        ],
        sonkullanimYil: [
          '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017',
          '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032'
        ],
        selected: '',
        m: false,
        k: false,
        color: 'info',
        dialog: false,
        search3: '',
        Firma: {
          KrediKartTip: '',
          Ay: '',
          Yil: '',
          KrediKartNo: '',
          CariKod: '',
          MuhasebeKodu: null,
          BankaKod: '',
          PasifAktif: false,
          SirketKodu:null,
        },
        cari: '',
        state: [],
        progress: false,
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        kartno: '',
        selectkarttipi: '',
        selectsonkullanim: '',
        selectsonkullanimyil: '',
        muhkod: '',
        kartcari: '',
        bankkod: '',
        dictionary: {
          custom: {
            kartno: {
              required: () => this.$t('This-space-cannot-left-blank'),
              min: this.$t('Card-Number-Must-16-Digits')
            },
            name1: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            selectkarttipi: {
              required: () => this.$t('Please-select'),
            },
            kartcari: {
              required: () => this.$t('Please-select'),
            },
            selectsonkullanim: {
              required: () => this.$t('Please-select'),
            },
            selectsonkullanimyil: {
              required: () => this.$t('Please-select'),
            },
            muhkod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            bankkod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
      'pasifKayitlar':function(val){
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          var params = {
          CompanyCode: credentials.SirketKodu,
          Passive:val
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/FirmCard/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.progress = false

            this.text1 = this.$t('No-Records-Found')
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })
      }

    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          Passive:this.pasifKayitlar
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/FirmCard/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = this.$t('No-Records-Found')
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    methods: {
      dialogdeneme() {
        const handler = e => {
          if (e.keyCode === 27) {

          }
        }

      },
      deneme: function (value) {

        const handler = e => {

          if (e.keyCode === 27) {


          }
        }

        var karakterial = value[value.length - 1]
        return null;

        // this.inputed.push(value)
      },

      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false

        this.dialog_baslik = this.$t('Edit-Firm-Card')
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          KrediKartNo: v
        }
        this.$http.post(auth.API_URL + 'api/FirmCard/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.dialog = true
          this.Firma = response.body
          this.search = response.body.CariKod
        })
      },
      deletefirma: deletefirma,
      kartekle: kartekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
       filters: {
            aktifpasifgoruntu: function (t) {

              if (t==true) {
                return 'Pasif'
              } else {
                return 'Aktif'
              }
            },


        },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      muhasebekoducomp,
      cariaracomp
    },
  }

  function vazgec() {
    this.dialog = false
    this.search = ''
    this.kartcari = null
    this.selectkarttipi = ''
    this.selectsonkullanim = ''
    this.selectsonkullanimyil = ''
    // this.Firma.MuhasebeKodu = ''
    this.Firma.BankaKod = ''
    this.Firma.KrediKartNo = ''
  }


  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params1 = {
          CompanyCode: credentials.SirketKodu,
          Passive:this.pasifKayitlar
        }

this.Firma.SirketKodu=credentials.SirketKodu
        var params = this.Firma
        this.$http.post(auth.API_URL + 'api/FirmCard/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/FirmCard/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }

  function kartekle() {
    this.dialog = true
    this.Firma = {}
    this.dialog_baslik = this.$t('Add-Firm-Card')
    this.selectkarttipi = ''
    this.selectsonkullanim = ''
    this.selectsonkullanimyil = ''
    //  this.Firma.MuhasebeKodu = null
    this.Firma.BankaKod = ''
    this.Firma.KrediKartNo = ''
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()


  }

  function beforeMount() {

  }

  function deletefirma() {
    if (window.confirm(this.$t('Are-you-sure-you-want-to-delete-this-record'))) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var params1 = {
        CompanyCode: credentials.SirketKodu,
        Passive:this.pasifKayitlar,
      }
      var params ={
            CompanyCode :credentials.SirketKodu,
         KrediKartNo :this.Firma.KrediKartNo
      }
      this.$http.post(auth.API_URL + 'api/FirmCard/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          this.$http.post(auth.API_URL + 'api/FirmCard/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.search = response.body.Tarih
            this.dialog = false


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
          CompanyCode: credentials.SirketKodu,
          Passive:this.pasifKayitlar
        }
this.Firma.SirketKodu=credentials.SirketKodu
        var params = this.Firma

        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/FirmCard/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/FirmCard/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>